import { render } from "./PromotionComponent.vue?vue&type=template&id=7c2ef270&scoped=true"
import script from "./PromotionComponent.vue?vue&type=script&lang=js"
export * from "./PromotionComponent.vue?vue&type=script&lang=js"

import "./PromotionComponent.vue?vue&type=style&index=0&id=7c2ef270&scoped=true&lang=css"

import exportComponent from "/builds/phi-indonesia/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c2ef270"]])

export default __exports__